module.exports = __webpack_public_path__ + "img/5-5.2a10ad22.svg";